import { cn } from "@/utils/cn";
import React from "react";

const BaseTable = React.forwardRef(({ className, style, ...props }, ref) => (
  <table ref={ref} style={style} className={cn(className)} {...props} />
));
BaseTable.displayName = "BaseTable";

const TableHeader = React.forwardRef(({ className, ...props }, ref) => (
  <thead ref={ref} className={cn(className)} {...props} />
));
TableHeader.displayName = "TableHeader";

const TableBody = React.forwardRef(({ className, ...props }, ref) => (
  <tbody ref={ref} className={cn(className)} {...props} />
));
TableBody.displayName = "TableBody";

const TableFooter = React.forwardRef(({ className, ...props }, ref) => (
  <tfoot
    ref={ref}
    className={cn("bg-gray-200 font-medium", className)}
    {...props}
  />
));
TableFooter.displayName = "TableFooter";

const TableRow = React.forwardRef(({ className, ...props }, ref) => (
  <tr ref={ref} className={cn(className)} {...props} />
));
TableRow.displayName = "TableRow";

const TableHead = React.forwardRef(({ className, style, ...props }, ref) => (
  <th ref={ref} className={cn(className)} style={style} {...props} />
));
TableHead.displayName = "TableHead";

const TableCell = React.forwardRef(({ className, style, ...props }, ref) => (
  <td ref={ref} style={style} className={cn(className)} {...props} />
));
TableCell.displayName = "TableCell";

export {
  BaseTable,
  TableHeader,
  TableBody,
  TableFooter,
  TableHead,
  TableRow,
  TableCell,
};
